<mat-dialog-content
  class="portfolio-kpi-expanded-view"
  [ngClass]="{
    'portfolio-kpi-expanded-view--cycle-chart':
      data.type === 'chart' && data.chartCardType === 'cycle'
  }"
>
  <div class="portfolio-kpi-expanded-view-header">
    <h4>{{ data.title }}</h4>
    <div
      class="portfolio-kpi-expanded-view-actions"
      [class.portfolio-kpi-expanded-view-actions--chart]="data.type === 'chart'"
    >
      <mat-icon
        svgIcon="close"
        class="portfolio-kpi-expanded-view-close"
        (click)="close()"
      ></mat-icon>
      <filter-menu
        *ngIf="data.type === 'chart'"
        [variant]="'kpi-expanded'"
        [label]="'Filters'"
        [columnTitleMappings]="data.columnTitleMappings ?? {}"
        [useExternalState]="true"
        [externalFiltersApplied]="kpiFiltersApplied"
        [externalTotalFiltersApplied]="totalKpiFiltersApplied"
        (externalRemoveFilter)="onKpiRemoveFilter($event)"
        (externalClearAll)="onKpiClearAllFilters()"
      ></filter-menu>
    </div>
  </div>

  <section
    class="portfolio-kpi-expanded-view-body"
    *ngIf="data.type === 'chart'; else tableTemplate"
  >
    <kpi-chart-card
      [title]="data.title"
      [variant]="'fullscreen'"
      [cardType]="data.chartCardType ?? 'cycle'"
      [isLoading]="isLoading"
      [timeCycleChartData]="timeCycleChartData"
      [milestoneStatusSummaryData]="milestoneStatusSummaryData"
      (summaryStatusClicked)="onSummaryStatusClicked($event)"
      [showHeader]="false"
      [framed]="false"
    ></kpi-chart-card>
  </section>

  <ng-template #tableTemplate>
    <section class="portfolio-kpi-expanded-view-table">
      <kpi-table-card [mode]="'fullscreen'" [showHeader]="false" [showExpandButton]="false">
        <filter-menu
          kpiTableLeadingAction
          [variant]="'kpi-expanded'"
          [label]="'Filters'"
          [columnTitleMappings]="data.columnTitleMappings ?? {}"
          [useExternalState]="true"
          [externalFiltersApplied]="kpiFiltersApplied"
          [externalTotalFiltersApplied]="totalKpiFiltersApplied"
          (externalRemoveFilter)="onKpiRemoveFilter($event)"
          (externalClearAll)="onKpiClearAllFilters()"
        ></filter-menu>
      </kpi-table-card>
    </section>
  </ng-template>
</mat-dialog-content>
